import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class PWAService {

  constructor(private swUpdate: SwUpdate) {}

  check() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe((evt: any) => {
        // an update is available, add some logic here.
        if (confirm('A new version of this web app is available. Load new version?')) {
          // console.log('an update is available, kindly force a reload')
          window.location.reload();
        }
      });
    }
  }
}
